export interface FinancialStatementOffer {
  companyId: string;
  companyName: string;
  beforeFirstResults: boolean;
  attachedReportName?: string;
}

export const FINANCIAL_STATEMENT_OFFER_COPY =
  'Add financial statements to see risks and opportunities in money. Materiality can look quite different with financials. This is optional: you can add them later from Edit company or in chat.';
